import React from 'react';
import { Modal, Icon } from 'antd';

const OptionModal = ({
  visible,
  onOk,
  onCancel,
  title,
  body,
  okText,
  cancelText,
  width,
  okButtonProps
}) => (
  <div>
    <Modal
      bodyStyle={{ padding: 20 }}
      title={title}
      visible={visible}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      onCancel={onCancel}
      width={width}
      okButtonProps={okButtonProps}
    >
      <p>
        <Icon type="exclamation-circle" /> {body}
      </p>
    </Modal>
  </div>
);

export default OptionModal;
